import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { Route, Switch } from 'react-router-dom';
import loadable from '@loadable/component';

import { useGetStandortPath } from '../components/VHost/StandortRoute';
import { useSelector } from 'react-redux';
import { currentHostIsShopSystemSelector } from '../../modules/selectors/hosts';
import { useStandortHistory } from '../components/VHost/StandortHistory';

import _ from 'lodash';
import StandortRedirect from '../components/VHost/StandortRedirect';

const HomeSelector = loadable(() => import('./Home/HomeSelector'));
const Footerpages = loadable(() => import('./Footerpages/Footerpages'));
const NotFound = loadable(() => import('./ErrorPages/NotFound/NotFound'));

export default function APSRoutes() {
    const currentHostIsShopSystem = useSelector(currentHostIsShopSystemSelector);

    const getStandortPath = useGetStandortPath({ currentHostIsShopSystem });

    const history = useStandortHistory();
    return (
        <Switch>
            {/* Footerlinks */}
            <Route exact path={getStandortPath('/impressum')}>
                {props => (
                    <Footerpages {...props} history={history} withoutBreadCrumbs={true} />
                )}
            </Route>
            <Route exact path={getStandortPath('/copyright')}>
                {props => (
                    <Footerpages {...props} history={history} withoutBreadCrumbs={true} />
                )}
            </Route>
            <Route exact path={getStandortPath('/datenschutz')}>
                {props => (
                    <Footerpages {...props} history={history} withoutBreadCrumbs={true} />
                )}
            </Route>
            {/* Home */}
            <Route exact path={getStandortPath(['/home', '/'])}>
                <HomeSelector />
            </Route>
            <Route>
                <StandortRedirect to="/" />
            </Route>
        </Switch>
    );
}
